import Button from 'Components/Atoms/Button/Button';
import classes from './ErrorFallback.module.css';
import imageWrongPass from 'assets/icon-wrong-pass.svg';
import { Trans, useTranslation } from 'react-i18next';

const ErrorFallback = () => {
    const { t } = useTranslation('common');

    const handleClick = () => {
        window.location.href = '/';
    };

    return (
        <div className={classes.page}>
            <div className={classes.container}>
                <div className="flex justify-center mb-6">
                    <img src={imageWrongPass} width={75} height={75} alt="" />
                </div>
                <div className="mb-6">
                    <h3 className="font-medium">{t('unknown-error')}</h3>
                    <div className="mt-2 text-gray-500">
                        <Trans t={t} i18nKey="unknown-error-description" />
                    </div>
                </div>
                <Button onClick={handleClick}>{t('close')}</Button>
            </div>
        </div>
    );
};

export default ErrorFallback;
